import React from 'react';

import { ButtonStyled, WrapperIcon } from './styles';

export default function Button(props) {
  const { children, startIcon, endIcon } = props;

  return (
    <ButtonStyled {...props}>
      <WrapperIcon>
        {startIcon && startIcon}
        {children}
        {endIcon && endIcon}
      </WrapperIcon>
    </ButtonStyled>
  );
}
